import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../config/serverApiConfig";
import Cookies from "js-cookie";
import { Toaster, toast } from "react-hot-toast";
import CandidateProfileCard from "../../components/candidate/cards/CandidateProfileCard";
import CandidateFilters from "../../components/candidate/filters/candidateFilters";

function RisCandidateList() {
    const [loader, setLoader] = useState(false);
    const [page, setPage] = useState(0);
    const [error, setError] = useState(null);
    const [candidateProfiles, setCandidateProfiles] = useState([]);
    const [filters, setFilters] = useState({
        candidatLicensePermis: null,
        candidatLanguages: null,
        enteredBy: null,
        candidatStatus: null,
    });

    const handleFilterChange = (filterName, value) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [filterName]: value ? value : null,
            transferredToRIS: true,
        }));
    };

    const fetchUnfilteredProfiles = async (page, signal) => {
        setLoader(true);

        try {
            const response = await fetch(API_BASE_URL + `getRISCandidates${page ? `?skip=${page}` : ""}`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + Cookies.get("token"),
                },
                signal, // Directly pass the signal here
            });

            const reD = await response.json();

            if (page) {
                setCandidateProfiles([...candidateProfiles, ...reD.data]);
            } else {
                setCandidateProfiles([...reD.data]);
            }
        } catch (err) {
            if (err.name === "AbortError") {
                console.log("Fetch aborted");
            } else {
                console.error("Error fetching profile:", err);
            }
        } finally {
            setLoader(false);
        }
    };

    const fetchFilteredProfiles = async (page, signal) => {
        setLoader(true);

        try {
            const endpoint = constructEndpointWithParams(API_BASE_URL, 'getCandidats', filters, page);

            const response = await fetch(endpoint, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + Cookies.get("token"),
                },
                signal
            });

            const filteredResponse = await response.json();
            if (page) {
                setCandidateProfiles([...candidateProfiles, ...filteredResponse.data]);
            } else {
                setCandidateProfiles([...filteredResponse.data]);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoader(false);
        }
    };

    const loadMoreHandle = (i: any) => {
        let isNearBottom = i.target.scrollHeight - i.target.clientHeight - i.target.scrollTop < 50;

        if (isNearBottom) {
            setPage((prevPage) => prevPage + 20);
        }
    }

    const constructEndpointWithParams = (baseUrl, endpoint, filters, page) => {
        // Add the filters to the query params
        const cleanedFilters: any = Object.fromEntries(
            Object.entries(filters).filter(([_, value]) => value) // Only include non-null filters
        )
        // Initialize URLSearchParams
        const params = new URLSearchParams(cleanedFilters);

        // Add the skip parameter for pagination if it exists
        if (page) {
            params.append('skip', page);
        }

        // Construct the full URL
        return `${baseUrl}${endpoint}?${params.toString()}`;
    };

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const isFiltersEmpty = (filters) => {
            return Object.values(filters).every((value) => value === null);
        };

        if (!isFiltersEmpty(filters)) {
            fetchFilteredProfiles(page, signal);
        } else {
            fetchUnfilteredProfiles(page, signal);
        }

        return () => {
            controller.abort();
        };
    }, [page]);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        const isFiltersEmpty = (filters) => {
            return Object.values(filters).every((value) => value === null);
        };

        setPage(0);
        if (!isFiltersEmpty(filters)) {
            fetchFilteredProfiles(page, signal);
        } else {
            fetchUnfilteredProfiles(page, signal);
        }

        return () => {
            controller.abort();
        };
    }, [filters]);

    return (
        <>
            <Toaster
                position="top-right"
                containerStyle={{ zIndex: "99999999999" }}
            />

            <div
                className="container-fluid cardScrollBar"
                onScroll={loadMoreHandle}
                style={{ overflowY: "auto", height: "100vh" }}
            >
                <div className="row pd">
                    {/* Info Bar */}
                    <div
                        className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 card-tops px-1 mt-1"
                        style={{ padding: "0px", marginBottom: "20px" }}
                    >
                        <div className="row text-start">
                            <div
                                className="card mdquery"
                                style={{
                                    padding: "15px 15px",
                                    borderRadius: "10px",
                                    marginBottom: "0px",
                                }}
                            >
                                <div className="d-flex topHeading">
                                    {" "}
                                    <h2 className="">candidates/employees</h2>{" "}
                                </div>
                                <p className="h-child-text d-flex mb-0 fw-bold">
                                    Here you have the list of candidates transferred from Intermann
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Filters */}
                    <CandidateFilters onFilterChange={handleFilterChange} />

                    {/* Candidate Profiles */}
                    {candidateProfiles.length > 0 ? (
                        candidateProfiles.map((profile, index) => (
                            <div className="md:tw-w-1/3 3xl:tw-w-1/4 tw-flex tw-my-2" key={index}>
                                <CandidateProfileCard data={profile} />
                            </div>
                        ))
                    ) : (
                        <div className="tw-w-full tw-justify-center tw-text-gray-500 tw-flex tw-items-center tw-my-10 tw-text-2xl">
                            No Candidates Found.
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default RisCandidateList;